import { NomenclatureHistory } from 'pages/Nomenclature/View/Recipes/NomenclatureHistory';

import { Material, Recipes } from '../../pages';

export const routingNomenclature = [
  {
    path: '/materials',
    exact: true,
    component: Material,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/recept',
    exact: true,
    component: Recipes,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/nomenclature-history/:id',
    exact: true,
    component: NomenclatureHistory,
    claims: ['CanLookNomenclatureHistory'],
  },
];
